// Portuguese (Brazil)

export default {

  component: {
    jobAdList: {
      title: 'Vagas abertas',
      jobs: 'vagas',
      noJobAds: 'Não há vagas abertas atualmente.',
    },

    jobAdCard: {
      openUntil: date => `Aberto até ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Obrigado.',
      readyInfo: 'Sua inscrição foi recebida e um(a) recrutador(a) entrará em contato com você em breve.',
      luck: 'Boa sorte!',
    },

    jobAdSeeYou: {
      title: 'Obrigado.',
      description: 'Sua candidatura foi salva e enviamos um link para concluí-la mais tarde.',
    },

    unpublished: {
      title: 'Não publicado',
      info: 'O anúncio de emprego ainda não foi publicado.',
    },
  },

  page: {},

}
